import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=2d1e0da4&scoped=true"
import script from "./dashboard.ts?vue&type=script&lang=ts&external"
export * from "./dashboard.ts?vue&type=script&lang=ts&external"
import style0 from "./dashboard.less?vue&type=style&index=0&id=2d1e0da4&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1e0da4",
  null
  
)

export default component.exports